import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { isArray as _isArray, reduce as _reduce } from 'lodash';
import { configDefaults } from '@gisatcz/ptr-core';
import { utils as tileGridUtils } from '@gisatcz/ptr-tile-grid';
/**
 * Compare wanted tiles from filter with already loaded or loading tiles and give array of missing tiles in string format
 * @param {Object} index Already loaded index
 * @param {Object} filter Required filter
 * @param {Array.<string|Array.<number>>} filter.tiles
 * @param {number} filter.level
 * @returns {Array?} Array of missing tiles in stringArray format
 */

export var getMissingTiles = function getMissingTiles(index, filter) {
  if (index && index.index && filter && _isArray(filter.tiles)) {
    var _index$index;

    //index contains level
    if ((_index$index = index.index) !== null && _index$index !== void 0 && _index$index[filter.level]) {
      var loadedTilesInIndex = _reduce(index.index[filter.level], function (acc, tileData, tileKey) {
        //tileData === true means it is loading, so we mark them as not missing
        if (tileData) {
          //re-save tile as array to prevent negative zero
          return [].concat(_toConsumableArray(acc), [tileGridUtils.tileAsString(tileKey)]);
        } else {
          return acc;
        }
      }, []);

      var missingTiles = filter.tiles.filter(function (tile) {
        return !loadedTilesInIndex.includes(tileGridUtils.tileAsString(tile));
      });
      return missingTiles;
    } else {
      // no data for requested level
      // all tiles are missing
      return filter.tiles.map(function (tile) {
        return tileGridUtils.tileAsStringArray(tile);
      });
    }
  } else {
    if (_isArray(filter === null || filter === void 0 ? void 0 : filter.tiles)) {
      // all tiles are missing
      return filter.tiles.map(function (tile) {
        return tileGridUtils.tileAsStringArray(tile);
      });
    } else {
      //filter is not defined
      return null;
    }
  }
};
/**
 * Central method for getting PAGE_SIZE from state or configDefaults.
 * @param {Object} localConfig Configuration with overrides
 * @return {Number}
 */

export function getPageSize(localConfig) {
  var PAGE_SIZE = (localConfig === null || localConfig === void 0 ? void 0 : localConfig.requestPageSize) || configDefaults.requestPageSize;
  return Number(PAGE_SIZE);
}
/**
 * Pick nearest tiles for requested level.
 * @param {number} level Required data for level. Search for closest tiles to this level.
 * @param {Object} loadedHigher Set of tiles from higher levels. {[tileKey]: {level:[level], tiles: [...[tileKey]]}}
 * @param {Object} loadedLower Set of tiles from lower levels. {[tileKey]: {level:[level], tiles: [...[tileKey]]}}
 * @param {string} preferedLevelsDirection One of [LOWER, HIGHER]. If fit tile is found on same level distance from requested level from lower and higher loaded tiles, which one is prefered.
 * @returns {Object}
 */

export function filterNearestTiles(level) {
  var loadedHigher = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var loadedLower = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var preferedLevelsDirection = arguments.length > 3 ? arguments[3] : undefined;
  var uniqueTiles = {};
  var uniqueLoadedKeys = new Set([].concat(_toConsumableArray(Object.keys(loadedHigher)), _toConsumableArray(Object.keys(loadedLower))));

  var _iterator = _createForOfIteratorHelper(uniqueLoadedKeys),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _tileKey = _step.value;
      var lowerTile = loadedLower[_tileKey];

      if (lowerTile) {
        lowerTile.levelDistance = Math.abs(level - lowerTile.level);
      }

      var higherTile = loadedHigher[_tileKey];

      if (higherTile) {
        higherTile.levelDistance = Math.abs(level - higherTile.level);
      } // tile only in higher or lower


      if (lowerTile && !higherTile || !lowerTile && higherTile) {
        uniqueTiles[_tileKey] = lowerTile || higherTile;
      } else {
        //if tile occure in both, then choose nearest or by preferedLevelsDirection
        if (lowerTile.levelDistance !== higherTile.levelDistance) {
          // one of tiles is on closer level to the required "level"
          var tileWithLessLevelDistance = lowerTile.levelDistance < higherTile.levelDistance ? lowerTile : higherTile;
          uniqueTiles[_tileKey] = tileWithLessLevelDistance;
        } else {
          // both tiles are on same levelDistance
          if (preferedLevelsDirection === 'LOWER') {
            uniqueTiles[_tileKey] = lowerTile;
          } else {
            uniqueTiles[_tileKey] = higherTile;
          }
        }
      }
    } //remove levelDistance property

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  for (var _i = 0, _Object$keys = Object.keys(uniqueTiles); _i < _Object$keys.length; _i++) {
    var tileKey = _Object$keys[_i];
    delete uniqueTiles[tileKey].levelDistance;
  }

  return uniqueTiles;
}